import { FeatureFields, UserFeatureFields } from '../mutations/UserSurvey';
import { gql } from '@apollo/client';

export const GET_FEATURE_BY_ID= gql`
${UserFeatureFields}
${FeatureFields}
  query featureById($id: String!) {
    feature(id: $id) {
        ...FeatureFields
        userFeature {
            ...UserFeatureFields
        }
    }
  }
`;